import styles from "../../../../styles/Components/new-insight/create-strategy/CreateStrategyForm.module.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { FaRegEdit } from "react-icons/fa";
import { Select } from "antd";
import { FaCircleCheck } from "react-icons/fa6";
import { IoIosCloseCircle } from "react-icons/io";
import { useStrategy } from "../useCreateStrategyContext";
const { Option } = Select;

function StrategyLabel() {
  const {
    newInsightState: {
      createStrategyResult: { labels, strategy_label: label },
    },
  } = useSelector((state) => state);

  const {
    state: { strategyLabel },
    setLabel,
  } = useStrategy();

  return (
    <div className={styles.formItem}>
      <h5 className={styles.label}>Label:</h5>
      <div className={styles.editBox}>
        <Select
          value={strategyLabel || []}
          onChange={(e) => {
            console.log(e);
            setLabel(e);
            // setSelectedLabel()
          }}
          placeholder="Select label..."
          mode="multiple"
        >
          {labels.map((suggestion, index) => (
            <Option key={index} value={suggestion}>
              {suggestion}
            </Option>
          ))}
        </Select>
        {/*<span className={styles.submitEdit} onClick={() => setIsEditing(false)}>*/}
        {/*  <FaCircleCheck size={18} />*/}
        {/*</span>*/}
        {/*<span*/}
        {/*  className={styles.closeEdit}*/}
        {/*  onClick={() => {*/}
        {/*    setSelectedLabel("");*/}
        {/*    setIsEditing(false);*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <IoIosCloseCircle size={22} />*/}
        {/*</span>*/}
      </div>
      {/*{!isEditing && (*/}
      {/*  <div className={styles.formInput}>*/}
      {/*    <span className={styles.value}>{selectedLabel || label}</span>*/}
      {/*    <span*/}
      {/*      className={styles.edit}*/}
      {/*      onClick={() => {*/}
      {/*        setIsEditing(true);*/}
      {/*        setSelectedLabel(labels?.[0]);*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <FaRegEdit size={16} />*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}

      {/*{isEditing && (*/}
      {/*  <div className={styles.editBox}>*/}
      {/*    <Select value={selectedLabel} onChange={setSelectedLabel}>*/}
      {/*      {labels.map((suggestion, index) => (*/}
      {/*        <Option key={index} value={suggestion}>*/}
      {/*          {suggestion}*/}
      {/*        </Option>*/}
      {/*      ))}*/}
      {/*    </Select>*/}
      {/*    <span*/}
      {/*      className={styles.submitEdit}*/}
      {/*      onClick={() => setIsEditing(false)}*/}
      {/*    >*/}
      {/*      <FaCircleCheck size={18} />*/}
      {/*    </span>*/}
      {/*    <span*/}
      {/*      className={styles.closeEdit}*/}
      {/*      onClick={() => {*/}
      {/*        setSelectedLabel("");*/}
      {/*        setIsEditing(false);*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <IoIosCloseCircle size={22} />*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*)}*/}
    </div>
  );
}

export default StrategyLabel;
